import React from "react"

import classNames from "classnames"

import { IconSize } from "shared/types/Icon"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { LinkWrapper, LinkWrapperProps } from "./LinkWrapper"

export interface LinkProps extends LinkWrapperProps {
  icon?: IconName
  iconSize?: IconSize
  isIconOnly?: boolean
}

export const Link = React.memo(
  React.forwardRef(
    (
      {
        icon,
        iconSize,
        isIconOnly,
        children,
        label,
        className,
        ...props
      }: LinkProps,
      ref: React.ForwardedRef<HTMLAnchorElement>
    ) => {
      const { disabled } = props
      return (
        <LinkWrapper
          ref={ref}
          className={classNames("link", className)}
          {...props}
        >
          {icon ? (
            <Icon
              name={icon}
              size={iconSize || IconSize.SMALL}
              className="link__icon"
            />
          ) : null}
          <div
            aria-hidden={disabled}
            className={classNames("link__content", {
              "visually-hidden": isIconOnly
            })}
          >
            {children || label}
          </div>
        </LinkWrapper>
      )
    }
  )
)
